// ==================== CLIENT SUPABASE POUR CONTOURNER RENDER ====================
// Ce client permet d'appeler directement les fonctions PostgreSQL de Supabase
// depuis le frontend, contournant ainsi les problèmes de routage Render

// Configuration Supabase
// IMPORTANT: Récupérez ces valeurs depuis votre dashboard Supabase
// Settings → API → Project URL et anon public key

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://srvscuamckwkblbjqbjs.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Fonction pour créer une demande de congé via Supabase RPC
export const createLeaveRequestViaSupabase = async (requestData, userToken) => {
  try {
    // Vérifier que Supabase est configuré
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY || SUPABASE_ANON_KEY === 'votre_anon_public_key_ici' || SUPABASE_ANON_KEY === '') {
      console.warn('⚠️ [SUPABASE] Configuration manquante - Supabase URL:', SUPABASE_URL, 'Key:', SUPABASE_ANON_KEY ? 'PRESENT' : 'MISSING');
      throw new Error('Supabase non configuré - vérifiez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY');
    }
    
    console.log('🔄 [SUPABASE] Création demande via Supabase RPC...');
    console.log('🔄 [SUPABASE] URL:', SUPABASE_URL);
    console.log('🔄 [SUPABASE] Données:', requestData);

    // Extraire le userId du token JWT
    let userId = null;
    if (userToken) {
      try {
        const payload = JSON.parse(atob(userToken.split('.')[1]));
        userId = payload.userId;
        console.log('🔄 [SUPABASE] UserId extrait du token:', userId);
      } catch (e) {
        console.error('❌ [SUPABASE] Erreur extraction userId:', e);
        throw new Error('Token invalide');
      }
    }

    if (!userId) {
      throw new Error('Utilisateur non authentifié');
    }

    // Préparer les paramètres pour la fonction PostgreSQL
    const params = {
      p_user_id: userId,
      p_leave_type_id: requestData.leaveTypeId,
      p_start_date: requestData.startDate,
      p_end_date: requestData.endDate,
      p_reason: requestData.reason || '',
      p_emergency_contact: requestData.emergencyContact || '',
      p_assigned_to: requestData.validators?.level1 || requestData.assignedTo || null,
      p_validator2: requestData.validators?.level2 || requestData.validator2 || null,
      p_validator3: requestData.validators?.level3 || requestData.validator3 || null
    };

    console.log('🔄 [SUPABASE] Paramètres RPC:', params);

    // Appeler la fonction PostgreSQL via Supabase RPC
    const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/create_leave_request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Prefer': 'return=representation'
      },
      body: JSON.stringify(params)
    });

    console.log('🔄 [SUPABASE] Réponse status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ [SUPABASE] Erreur HTTP:', errorText);
      throw new Error(`Erreur Supabase: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log('✅ [SUPABASE] Résultat:', result);

    // La fonction PostgreSQL retourne un JSON
    // Si c'est un tableau avec un seul élément, extraire l'élément
    if (Array.isArray(result) && result.length > 0) {
      const jsonResult = typeof result[0] === 'string' ? JSON.parse(result[0]) : result[0];
      return jsonResult;
    }

    // Si c'est déjà un objet JSON
    if (typeof result === 'object' && !Array.isArray(result)) {
      return result;
    }

    // Si c'est une chaîne JSON
    if (typeof result === 'string') {
      return JSON.parse(result);
    }

    return result;

  } catch (error) {
    console.error('❌ [SUPABASE] Erreur création demande:', error);
    throw error;
  }
};

// Fonction pour créer une note de frais via Supabase RPC
export const createExpenseReportViaSupabase = async (requestData, userToken) => {
  try {
    // Vérifier que Supabase est configuré
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY || SUPABASE_ANON_KEY === 'votre_anon_public_key_ici' || SUPABASE_ANON_KEY === '') {
      console.warn('⚠️ [SUPABASE] Configuration manquante - Supabase URL:', SUPABASE_URL, 'Key:', SUPABASE_ANON_KEY ? 'PRESENT' : 'MISSING');
      throw new Error('Supabase non configuré - vérifiez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY');
    }
    
    console.log('🔄 [SUPABASE] Création note de frais via Supabase RPC...');
    console.log('🔄 [SUPABASE] URL:', SUPABASE_URL);
    console.log('🔄 [SUPABASE] Données:', requestData);

    // Extraire le userId du token JWT
    let userId = null;
    if (userToken) {
      try {
        const payload = JSON.parse(atob(userToken.split('.')[1]));
        userId = payload.userId;
        console.log('🔄 [SUPABASE] UserId extrait du token:', userId);
      } catch (e) {
        console.error('❌ [SUPABASE] Erreur extraction userId:', e);
        throw new Error('Token invalide');
      }
    }

    if (!userId) {
      throw new Error('Utilisateur non authentifié');
    }

    // Préparer les paramètres pour la fonction PostgreSQL
    const params = {
      p_user_id: userId,
      p_title: requestData.title,
      p_expense_date: requestData.expense_date,
      p_description: requestData.description || null,
      p_purpose: requestData.purpose || null,
      p_project_code: requestData.project_code || null,
      p_items: requestData.items || []
    };

    console.log('🔄 [SUPABASE] Paramètres RPC:', params);

    // Appeler la fonction PostgreSQL via Supabase RPC
    const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/create_expense_report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Prefer': 'return=representation'
      },
      body: JSON.stringify(params)
    });

    console.log('🔄 [SUPABASE] Réponse status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ [SUPABASE] Erreur HTTP:', errorText);
      throw new Error(`Erreur Supabase: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log('✅ [SUPABASE] Résultat:', result);

    // La fonction PostgreSQL retourne un JSON
    // Si c'est un tableau avec un seul élément, extraire l'élément
    if (Array.isArray(result) && result.length > 0) {
      const jsonResult = typeof result[0] === 'string' ? JSON.parse(result[0]) : result[0];
      return jsonResult;
    }

    // Si c'est déjà un objet JSON
    if (typeof result === 'object' && !Array.isArray(result)) {
      return result;
    }

    // Si c'est une chaîne JSON
    if (typeof result === 'string') {
      return JSON.parse(result);
    }

    return result;

  } catch (error) {
    console.error('❌ [SUPABASE] Erreur création note de frais:', error);
    throw error;
  }
};

// Fonction pour créer une idée via Supabase RPC (fonction PostgreSQL)
export const createIdeaViaSupabase = async (ideaData, userToken) => {
  try {
    // Vérifier que Supabase est configuré
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY || SUPABASE_ANON_KEY === 'votre_anon_public_key_ici' || SUPABASE_ANON_KEY === '') {
      console.warn('⚠️ [SUPABASE] Configuration manquante');
      throw new Error('Supabase non configuré - vérifiez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY');
    }

    console.log('🔄 [SUPABASE] Création idée via Supabase RPC...');
    
    // Extraire userId du token JWT
    let userId;
    try {
      const tokenParts = userToken.split('.');
      const payload = JSON.parse(atob(tokenParts[1]));
      userId = payload.userId;
      console.log('🔄 [SUPABASE] UserId extrait:', userId);
    } catch (e) {
      console.error('❌ [SUPABASE] Erreur extraction userId:', e);
      throw new Error('Token invalide');
    }

    if (!userId) {
      throw new Error('Utilisateur non authentifié');
    }

    // Préparer les paramètres pour la fonction PostgreSQL
    const params = {
      p_user_id: userId,
      p_title: ideaData.title.trim(),
      p_description: ideaData.description.trim(),
      p_category_id: ideaData.category_id || null,
      p_is_anonymous: ideaData.is_anonymous === 'true' || ideaData.is_anonymous === true || ideaData.is_anonymous === '1',
      p_attachments: ideaData.attachments || null
    };

    console.log('🔄 [SUPABASE] Paramètres RPC:', params);

    // Appeler la fonction PostgreSQL via Supabase RPC
    const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/create_idea`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Prefer': 'return=representation'
      },
      body: JSON.stringify(params)
    });

    console.log('🔄 [SUPABASE] Réponse status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ [SUPABASE] Erreur HTTP:', errorText);
      throw new Error(`Erreur Supabase: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    console.log('✅ [SUPABASE] Résultat:', result);

    // La fonction PostgreSQL retourne un JSON
    // Si c'est un tableau avec un seul élément, extraire l'élément
    if (Array.isArray(result) && result.length > 0) {
      const jsonResult = typeof result[0] === 'string' ? JSON.parse(result[0]) : result[0];
      return jsonResult;
    }

    // Si c'est déjà un objet JSON
    if (typeof result === 'object' && !Array.isArray(result)) {
      return result;
    }

    // Si c'est une chaîne JSON
    if (typeof result === 'string') {
      return JSON.parse(result);
    }

    return result;

  } catch (error) {
    console.error('❌ [SUPABASE] Erreur création idée:', error);
    throw error;
  }
};

